import { useState } from 'react';
import Button from './Button'

interface ButtonWithConfirmationProps {
    onClick: () => void | Promise<void>;
    firstText: string;
    secondText: string;
    firstIcon: React.ReactNode;
    secondIcon: React.ReactNode;
    firstVariant: 'primary' | 'secondary' | 'success' | 'danger' | 'outline' | 'ghost' | 'tab' | 'tab-active';
    secondVariant: 'primary' | 'secondary' | 'success' | 'danger' | 'outline' | 'ghost' | 'tab' | 'tab-active';
    size?: 'sm' | 'md' | 'lg';
}

export const ButtonWithConfirmation = ({ onClick, firstText, secondText, firstIcon, secondIcon, firstVariant, secondVariant, size = 'md' }: ButtonWithConfirmationProps) => {
    const [isConfirming, setIsConfirming] = useState(false);

    const handleFirstClick = () => {
        setIsConfirming(true);
    }

    const handleSecondClick = async () => {
        setIsConfirming(false);
        await onClick();
    }

    return (
        <>
            {!isConfirming ?
                <Button onClick={handleFirstClick} icon={firstIcon} variant={firstVariant} size={size}>{firstText}</Button> :
                <Button onClick={handleSecondClick} icon={secondIcon} variant={secondVariant} size={size}>{secondText}</Button>}
        </>
    )
}